<form focusInvalidInput *ngIf="bcForm" [formGroup]="bcForm">
    <div class="row">
        <div class="col-sm-12" style="display: flex; justify-content: space-between;">
            <h3 class="col-sm-4"> Livraison {{bc.type === definitionTypeBC.BCEnveloppe ? " enveloppe " : ""}} {{bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx"}} {{this.bc.societe ? '(' + this.bc.societe.code + ')' : ''}}</h3>
            <div class="col-sm-8" style=" justify-content: space-between;">

                <button color="default" mat-raised-button type="button" (click)="close()">
                    <mat-icon>arrow_back</mat-icon>&nbsp;Retour à la liste
                </button>

                <button [color]="'primary'" mat-raised-button
                    type="button" (click)="openCycleValidation()">
                    <mat-icon>share</mat-icon>Cycle de validation
                </button>

                <app-pdf-bc [bc]="bc"></app-pdf-bc>
                
                <button color="success" mat-raised-button type="button" (click)="litiger()"
                [disabled]="this.bc.fLivre === 2 && this.bc.fAnnule === 2">
                    <mat-icon>send</mat-icon>&nbsp;Enregistrer l’action
                </button>
                <button color="warn" mat-raised-button type="button" (click)="lettrageBpInfo()">
                    <mat-icon>info</mat-icon>&nbsp;Info lettrage
                </button>
                <button color="success" mat-raised-button type="button" (click)="deliverAll()"
                *ngIf="this.bcForm.get('fLivre').value !== 2 && this.bcForm.get('type').value === definitionTypeBC.BCStandard" [matTooltip]="'Livrer toutes les lignes'">
                    <mat-icon>send</mat-icon>&nbsp;Livrer tout
                </button>
                <button *ngIf="this.bcForm.get('fLivre').value !== 0 ? true: false" color="success" mat-raised-button type="button" (click)="litigerAll()" [matTooltip]="'Litiger tout'">
                    <mat-icon>send</mat-icon>&nbsp;Litiger tout
                </button>
                <button color="primary" [disabled]="this.bc.statusNum < 10"
                mat-raised-button type="button" (click)="sendEmail()">
                    <mat-icon>email</mat-icon>Envoyer
                </button>
                <button color="warn" [hidden]="this.bc.type == definitionTypeBC.BCStandard" [disabled]="this.bc.statusNum < 10 && this.bc.type == definitionTypeBC.BCEnveloppe"
                mat-raised-button type="button" (click)="litiger(true)">
                    <mat-icon>warning</mat-icon>Cloturer
                </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <app-bc-form [form]="bcForm" [detailBcInfo]="detailBcInfos" [amountHT]="bcLineHTs" [amountTTC]="bcLineTTCs"
                [amountTVA]="bcLineTVAs">
            </app-bc-form>
            <br/>
            <mat-card>
                <mat-card-content>
                    <app-edit-bc-line-list *ngIf="bc.type === definitionTypeBC.BCStandard" class="row" [form]="bcForm" [modeRead]="false" (selected)="changeAnnule($event)"></app-edit-bc-line-list>
                    <app-edit-bc-env-line-list *ngIf="bc.type === definitionTypeBC.BCEnveloppe" class="row" [form]="bcForm" [modeRead]="false" (selected)="changeAnnule($event)"></app-edit-bc-env-line-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</form>